import { useSubscription } from '@apollo/client'

import { UNREAD_FEEDBACK_MESSAGES } from './api'
import type { FeedbackSide } from './useFeedbackMessages'

/**
 * Ungelesene Feedback-Nachrichten der Gegenseite, laufend aktuell. Wie bei
 * useUnreadChatMessages zeigt ein Fehler nichts an - ohne die Zahl geht der Chat trotzdem.
 */
export function useUnreadFeedbackMessages(viewer: FeedbackSide) {
  const { data } = useSubscription(UNREAD_FEEDBACK_MESSAGES, {
    variables: { fromMember: viewer === 'institute' },
  })
  return data?.feedback_messages ?? []
}
